export default __webpack_public_path__ + "static/media/newyear2.272916d1.png";